export { default } from "./Heading";
export type { HeadingProps } from "./Heading";
